import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsGithub, BsYoutube, BsBrowserChrome, BsEye } from "react-icons/bs";
import "./portfolio.css";
import { recentProjects } from "../../data/projects-data";

const Portfolio = () => {
  const { t } = useTranslation();

  return (
    <section id="portfolio">
      <h4>{t("portfolio.subtitle")}</h4>
      <h2>{t("portfolio.title")}</h2>

      <div className="container portfolio__container">
        {recentProjects.map(
          ({ id, image, title, description, github, demo, video, stack }) => {
            return (
              <article key={id} className="projects__item">
                <h3 className="projects__item-title">{title}</h3>
                <div className="projects__item-image">
                  <img src={image || "/placeholder.svg"} alt="projects" />
                </div>
                {/* <p>{t(`portfolio.descriptions.description${id}`)}</p> */}
                <div className="projects__tech-stack">
                  {stack &&
                    stack.map((tech, index) => (
                      <span key={index} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                </div>
                <div className="projects__item-cta">
                  <Link
                    className="btn"
                    to={`/project/${id}`}
                    title="Ver Detalhes"
                  >
                    <BsEye className="btn__icon" />
                  </Link>
                  <a
                    className="btn"
                    href={github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsGithub className="btn__icon" />
                  </a>
                  <a
                    className="btn"
                    href={demo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsBrowserChrome className="btn__icon" />
                  </a>
                  <a
                    className="btn"
                    href={video}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsYoutube className="btn__icon" />
                  </a>
                </div>
              </article>
            );
          }
        )}
      </div>

      <div className="projects__button-container">
        <Link to="/projects" className="see__all_buttom">
          {t("portfolio.seeAll")}
        </Link>
      </div>
    </section>
  );
};

export default Portfolio;
